<template>

<com-item name="game.peers.overview" :size="size" :is-overview="4" :loading="loading" :is-empty="!active" title="Overview">

	<template v-slot:about>

		<p>This game across geekGroup users.</p>

	</template>

	<template v-slot:stats>

		<com-overview label="Own" type="number" :value="data.owners" v-if="data.owners" />
		<com-overview label="Own" type="number" :empty="true" v-if="!data.owners" />

		<com-overview label="Prev Owned" type="number" :value="data.prevowners" v-if="data.prevowners" />
		<com-overview label="Prev Owned" type="number" :empty="true" v-if="!data.prevowners" />

		<com-overview label="Wishlisted" type="number" :value="data.wishlisted" v-if="data.wishlisted" />
		<com-overview label="Wishlisted" type="number" :empty="true" v-if="!data.wishlisted" />

		<com-overview label="Wish Convert" type="percent" :value="data.wishConvertRate" v-if="data.wishConvertRate !== null" />
		<com-overview label="Wish Convert" type="number" :empty="true" v-if="data.wishConvertRate === null" />

		<com-overview label="Avg Owned" type="template" :value="avgOwnedLabel" v-if="data.avgTimeOwned" />
		<com-overview label="Avg Owned" type="number" :empty="true" v-if="!data.avgTimeOwned" />

		<com-overview label="Total Plays" type="number" :value="data.totalPlays" v-if="data.totalPlays" />
		<com-overview label="Total Plays" type="number" :empty="true" v-if="!data.totalPlays" />

		<com-overview label="Avg Plays" type="number" :value="data.avgPlays" :value-label="'per user'" v-if="data.avgPlays" />
		<com-overview label="Avg Plays" type="number" :empty="true" v-if="!data.avgPlays" />

		<com-overview label="Total Hours" type="number" :value="totalHoursRounded" v-if="data.totalHours" />
		<com-overview label="Total Hours" type="number" :empty="true" v-if="!data.totalHours" />

		<com-overview label="Avg Duration" type="template" :value="avgDurationLabel" v-if="data.avgDuration" />
		<com-overview label="Avg Duration" type="number" :empty="true" v-if="!data.avgDuration" />

		<com-overview label="Players" type="number" :value="data.totalPlayers" v-if="data.totalPlayers" />
		<com-overview label="Players" type="number" :empty="true" v-if="!data.totalPlayers" />

		<com-overview label="Raters" type="number" :value="data.raters" v-if="data.raters" />
		<com-overview label="Raters" type="number" :empty="true" v-if="!data.raters" />

		<com-overview label="Avg Rating" type="rating" :value="data.avgRating" v-if="data.avgRating" />
		<com-overview label="Avg Rating" type="number" :empty="true" v-if="!data.avgRating" />

	</template>

</com-item>

</template>

<script>

import comOverview from './../common/Overview'
import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-overview': comOverview
	},

	computed: {

		loading: function() { return this.fetching === 'all' },

		data: function() { return this.$store.getters['page/insights/game/peers'] },

		active: function() { return this.data && !this.loading && this.data.owners },

		avgOwnedLabel: function() {

			if (!this.data || !this.data.avgTimeOwned) return ''
			return this.formatDays(this.data.avgTimeOwned)

		},

		totalHoursRounded: function() {

			if (!this.data || !this.data.totalHours) return 0
			return Math.round(this.data.totalHours)

		},

		avgDurationLabel: function() {

			if (!this.data || !this.data.avgDuration) return ''
			if (this.data.avgDuration >= 60) return Math.round(this.data.avgDuration / 60) + ' [hrs]'
			return this.data.avgDuration + ' [min]'

		}

	},

	methods: {

		formatDays: function(days) {

			if (days < 30) return days + ' [days]'
			if (days < 365) return Math.round(days / 30) + ' [months]'
			var years = Math.floor(days / 365)
			var months = Math.round((days % 365) / 30)
			if (months > 0) return years + '[y] ' + months + '[mo]'
			return years + ' [years]'

		}

	}

}

</script>

<style scoped>
</style>
